module.exports = __webpack_public_path__ + "img/08.52cace6e.png";